import {copilot, users} from '@cl/shared';
import {CLDispatch, RootState} from 'common/src/redux/store';
import saveChatsToLocalStorage from 'common/src/modules/shared/copilot/persistence/utils/saveChatsToLocalStorage';
import {ChatType} from '../../copilot.enums';
import assistantPlaintextChatItem from '../../utils/creators/assistantPlaintextChatItem';
import {addChat, addChatItem} from '../copilot.slice';
import chatState from '../../utils/creators/chatState';

function createChat(type: ChatType) {
  return (dispatch: CLDispatch, getState: () => RootState) => {
    const chat =
      type === ChatType.Support ? copilot.createSupportChat() : copilot.createGeneralChat();

    copilot.addChat(chat);

    const {id: chatId, isPlanModeEnabled} = chat;
    const {name: agentName} = chat.agents[0];

    const newReduxChat = chatState({chatId, type, isPlanModeEnabled});
    dispatch(addChat({chat: newReduxChat, setAsActive: true}));

    const userFirstName = users.userSubject.data?.firstName?.trim();
    const text = userFirstName
      ? `How can I help you today, ${userFirstName}?`
      : 'How can I help you today?';

    dispatch(
      addChatItem({
        chatId,
        chatItem: assistantPlaintextChatItem({agent: agentName, content: text}),
      }),
    );

    saveChatsToLocalStorage(getState);

    return chatId;
  };
}

export default createChat;
